import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { SubGroupDto, GroupDto, DivestmentStatusDto} from '@cradua/data';
import { NotificationService, ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';

@Component({
  selector: 'cradua-subgroup-container',
  templateUrl: './subgroup-container.component.html',
  styleUrls: ['./subgroup-container.component.scss']
})
export class SubGroupContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  divestmentstatuss$: Observable<DivestmentStatusDto[]>;
  groups$: Observable<GroupDto[]>;
  subgroups$: Observable<SubGroupDto[]>;
  loading: boolean;
  isLoadingDivestmentStatus$: Observable<boolean>;
  isLoadingGroup$: Observable<boolean>;
  isLoadingSubGroup$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoadingDivestmentStatus$ = this.gatwayFacade.isLoadingGateway("DivestmentStatus"); 
    this.isLoadingGroup$ = this.gatwayFacade.isLoadingGateway("Group");
    this.isLoadingSubGroup$ = this.gatwayFacade.isLoadingGateway("SubGroup");

    this.divestmentstatuss$ = this.gatwayFacade.loadGateway("DivestmentStatus");  
    this.groups$ = this.gatwayFacade.loadGateway("Group");
    this.subgroups$ = this.gatwayFacade.loadGateway("SubGroup");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteSubGroup(deletedValue: any) {
    this.gatwayFacade.remove("SubGroup", deletedValue);
  }

// this method control both the create and update
  onSubmitSubGroup(formValue: any) {
    const pullData = formValue.SubGroups;

// declare two empty array to hold update and create data
  const allUpdates = [] ;
  const addAllSubGroup = [];

// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id) {
      allUpdates.push(pullData[i]);
    } else {
      addAllSubGroup.push(pullData[i]);
    }
  }

// check if the addAllCountry array is not empty, then dispatch the data to the store
   if(addAllSubGroup.length > 0) {
    this.gatwayFacade.add('SubGroup', addAllSubGroup);
   }

// dispatch update data to the store
   if(allUpdates.length > 0) {
    this.gatwayFacade.update('SubGroup', allUpdates, ['id']);
   }
  }


}
